export enum FormType {
    contractSales = 'contractSales',
    brandGuide = 'brandGuide',
    whitePaper = 'whitePaper',
    tappingThePotentialOfSE = 'tappingThePotentialOfSE',
    practiceMakesPerformance = 'practiceMakesPerformance',
    // organizationalUseOfAiForTalentDevelopment = 'organizationalUseOfAiForTalentDevelopment',
    // aiInLearningAndTd = 'aiInLearningAndTd',
    bookDemo = 'bookDemo',
    aiEmpowermentOrganizationalTransformation = 'aiEmpowermentOrganizationalTransformation',
    aiFutureOfWork = 'aiFutureOfWork',
    talentTransformationAgeOfAi = 'talentTransformationAgeOfAi',
}

export enum ChannelType {
    brandGuide = 7,
    whitePaper = 4,
    practiceMakesPerformance = 4,
    // organizationalUseOfAiForTalentDevelopment = 6,
    aiEmpowermentOrganizationalTransformation = 4,
    aiFutureOfWork = 4,
    talentTransformationAgeOfAi = 4,
}

export interface IProp {
    type: FormType;
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
    downloadUrl?: string;
    hidePhoneArea?: boolean;
    acquisitionSource?: string;
    changeHasSubmitted?: (hasSubmitted: boolean) => void;
    contentComponent?: React.FunctionComponent<any> | React.ComponentClass<any, any>;
    fromProps?: React.ComponentProps<'form'>
}

export interface OptionItemType {
    id: string;
    label: string;
}

export interface ParamsType {
    first_name: string;
    last_name: string;
    phone: string;
    email: string;
    enterprise_name: string;
    position_name: string;
    source: string;
    description: string;
    channel_type?: number;
}
